<mat-card *ngIf="card.display != 'Off'" style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
  <div style="display: flex; flex-direction: column; flex: 1">
    <div class="header-color" style="display: flex; flex-direction: row;">
      <div class="robotoMedium" style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;">
          <span translate>Upcoming Events</span>
      </div>
      <div style="display: flex; flex-direction: row; padding: 5px">
        <div style="display: flex; flex-direction: column; flex: 1; align-items: flex-end; justify-content: center">
          <button mat-stroked-button class="mat-card-button" (click)="viewCalendarClick()"><span translate>Go To Calendar</span></button>
        </div>
      </div>
    </div>
    <div style="display: flex; flex-direction: column; padding-left: 10px; padding-top: 5px">
      <div *ngIf="!(upcomingEvents.length > 0)" style="display: flex;flex-direction: column;justify-content: center;align-items: center;padding: 15px;">
          <span translate>No upcoming events.</span>
      </div>
      <div *ngIf="upcomingEvents.length > 0">
        <div *ngFor="let eMonth of eventsByMonth" style="display: flex; flex-direction: column; flex: 1;">
          <div style="display: flex; flex-direction: column; flex: 1;">
            <span class="robotoMedium" style="font-size: 11pt">{{eMonth.month | translate}} {{eMonth.year}}</span>
            <div *ngFor="let event of eMonth.events" style="display: flex; flex-direction: row; padding: 10px">
              <div style="display: flex; flex-direction: column; flex: .2;justify-content: center;">
                <div class="robotoMedium" style="display: flex; flex-direction: row;justify-content: center; font-size: 20pt">
                  {{getDayString(event)}}
                </div>
                <div style="display: flex; flex-direction: row; font-size: 8pt; justify-content: center">
                  {{getWeekDayString(event) | translate}}
                </div>
              </div>
              <div style="display: flex; flex-direction: column; flex: 1; background-color: #F5F5F5; padding: 5px">
                <div style="display: flex; flex-direction: row; flex: 1; font-size: 11pt; align-items: center">
                  {{event.EventTitle}}
                </div>
                <div *ngIf="multiDayEvent(event)" style="display: flex; flex-direction: row; flex: 1; font-size: 9pt; padding-top: 3px">
                  {{getDateRangeString(event)}}
                </div>
                <div *ngIf="hasTimeLocation(event)" style="display: flex; flex-direction: row; flex: 1; font-size: 9pt">
                  {{getTimeLocationString(event)}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-card>
